import { IColumnMetadata } from "dots-ui/dotsTable";
import { PortalType } from "../models";
import { DotsDelimiter } from "dots-ui/dotsInputDecimal";

interface IAvisConfiguration {
  user_storage_key: string;
  texts_storage_key: string;
  resources_storage_key: string;
  selected_rights_holder_storage_key: string;
  rights_holders_storage_key: string;
  portal_settings_key: string;
  user_last_activity_time_key: string;
  session_expired_key: string;
  grid_filter_suffix: string;
  grid_data_suffix: string;
  grid_paginator_min_row_count: number;
  creations_filter_classes_key: string;
  creations_filter_statuses_key: string;
  creations_filter_statuses_unidentfied_key: string;
  creations_filter_values_key: string;
  creations_search_filter_values_key: string;
  licenses_filter_values_key: string;
  licenses_child_filter_values_key: string;
  invoices_archive_filter_values_key: string;
  licenses_reports_active_filter_values_key: string;
  licenses_creations_filter_values_key: string;
  licenses_creations_filter_classes_key: string;
  licenses_reports_pp_copy_param: string;
  blank_media_applications_filter_values_key: string;
  url_rights_holder_id_param: string;
  url_rights_holder_type_param: string;
  url_creation_type_param: string;
  url_id_param: string;
  url_report_form_type_param: string;
  url_invoice_plan_id_param: string;
  url_client_event_id_param: string;
  url_application_id_param: string;
  url_application_type_param: string;
  url_part_creations: string;
  url_part_unidentified: string;
  url_hash_filter: string;
  eId_return_url_login: string;
  eId_return_url_change_password: string;
  eId_return_to_portal_session_key: string;
  url_change_password: string;
  unknown_error_message: string;
  default_table_page_size: number;
  default_table_page_size_options: number[];
  date_format: string;
  date_format_calendar: string;
  date_format_ISO: string;
  table_default_column_metadata: IColumnMetadata;
  table_datetime_column_metadata: IColumnMetadata;
  table_column_period_width: number;
  table_column_license_number_width: number;
  notification_async_default_timeout: number;
  url_part_portal_authors: PortalType;
  url_part_portal_licensees: PortalType;
  url_part_portal_blank_media: PortalType;
  url_part_portal_public: PortalType;
  max_int_value: number;
  default_delimiter: DotsDelimiter;
}

export const AvisConstants: IAvisConfiguration = {
  default_delimiter: ",",
  user_storage_key: "USER",
  texts_storage_key: "TEXTS",
  resources_storage_key: "RESOURCES",
  selected_rights_holder_storage_key: "RIGHT_HOLDER",
  rights_holders_storage_key: "RIGHT_HOLDERS",
  portal_settings_key: "PORTAL_SETTINGS",
  user_last_activity_time_key: "USER_WAS_ACTIVE",
  session_expired_key: "EXPIRED",
  grid_filter_suffix: "_filter",
  grid_data_suffix: "_dataset",
  grid_paginator_min_row_count: 10,
  creations_filter_classes_key: "CREATION_CLASSES",
  creations_filter_statuses_key: "CREATION_STATUSES",
  creations_filter_statuses_unidentfied_key: "UNIDENTIFIED_CREATION_STATUSES",
  creations_filter_values_key: "CREATION_FILTER",
  creations_search_filter_values_key: "CREATION_SEARCH_FILTER",
  licenses_filter_values_key: "LICENSES_FILTER",
  licenses_child_filter_values_key: "CHILD_LICENSES",
  invoices_archive_filter_values_key: "INVOICES_ARCHIVE",
  licenses_reports_active_filter_values_key: "LICENSEREPORTS_ACTIVE",
  licenses_creations_filter_values_key: "PUBLIC_LICENSE_CREATIONS",
  licenses_creations_filter_classes_key: "PUBLIC_CREATION_CLASSES",
  licenses_reports_pp_copy_param: "copy",
  blank_media_applications_filter_values_key:
    "BLANKMEDIATYPE_APPLICATIONS_FILTER",
  url_rights_holder_id_param: ":rhId",
  url_rights_holder_type_param: ":rhType",
  url_creation_type_param: ":cType",
  url_id_param: ":id",
  url_report_form_type_param: ":rformType",
  url_invoice_plan_id_param: ":invoiceId",
  url_client_event_id_param: ":clientEventId",
  url_application_id_param: ":applicationId",
  url_application_type_param: ":applicationType",
  url_part_creations: "creations",
  url_part_unidentified: "unidentified",
  url_part_portal_authors: "authors",
  url_part_portal_licensees: "licensees",
  url_part_portal_blank_media: "blank-media",
  url_part_portal_public: "common",
  url_hash_filter: "#filter",
  eId_return_url_login: "/eId/Login",
  eId_return_url_change_password: "/eId/ConfirmPassword",
  eId_return_to_portal_session_key: "EID-PORTAL-RETURN",
  url_change_password: "/profile/change-password",
  unknown_error_message:
    "Atvainojiet, radās nezināma kļūda. Ja problēma atkārtojas, lūdzu, sazinieties ar info@akka-laa.lv", // in case if resources loading failed
  default_table_page_size: 10,
  default_table_page_size_options: [10, 25, 50],
  date_format: "DD.MM.YYYY",
  date_format_calendar: "dd.mm.yy",
  date_format_ISO: "YYYY-MM-DDTHH:mm:ss",
  table_default_column_metadata: {
    allowSort: false,
    disableDrag: true,
  },
  table_datetime_column_metadata: {
    allowSort: false,
    disableDrag: true,
    format: "DD.MM.yy",
  },
  table_column_period_width: 200,
  table_column_license_number_width: 150,
  notification_async_default_timeout: 200,
  max_int_value: 2147483647,
};
